<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Histórico' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <ion-card class="card-full">
    <ion-grid class="gradient-extendido-div">
      <ion-row>
        <ion-col size="1">
          <i class="fas fa-user-check div-icon"></i>
        </ion-col>

        <ion-col size="10">
          <ion-label> {{'Meus Acompanhamentos' | translate}} </ion-label>
        </ion-col>

        <ion-col size="1">
          <div id="open-modal">
            <i class="fa-regular fa-calendar"></i>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-row (click)="detalhes(historico)" *ngFor="let historico of historicoList">
      <ion-col size="11">
        <ion-card class="card card-compromisso">
          <ion-list>
            <ion-item lines="none">
              <div class="alinhamento-colum">
                <i [ngStyle]="{'color': getFontColor(historico)}" class="{{getIcon(historico)}} icone-acompanhamento">
                  <label class="titulo-item" [ngStyle]="{'color': getFontColor(historico)}"> {{historico.acao}} </label>
                </i>
                <span class="date margin-top-sm">{{historico.categoria}}</span>
              </div>
            </ion-item>

            <ion-item lines="none">
              <div class="alinhamento-colum">
                <p class="date">
                  {{'Status: ' | translate }}
                  <span
                    [ngClass]="{
                      'green': historico.tipo == '0', 
                      'red': historico.tipo == '2', 
                      'orange': historico.tipo == '1'
                    }"
                  >
                    {{historico.status | translate }}
                  </span>
                </p>

                <ion-label class="date" style="margin-top: 4px">
                  {{historico.datahora | dateFormat:"mediaHora"}}
                </ion-label>

                <p class="date margin-top-sm">
                  <i class="fa-solid fa-eye"></i>
                  <span> {{historico.restrito == '1' ? ('RESTRITO' | translate) : ('PÚBLICO' | translate)}} </span>
                </p>
              </div>
            </ion-item>

            <ion-item lines="none">
              <p class="date one-lines" *ngIf="historico.descricao">
                {{'Descrição: ' | translate }}
                <span> {{historico.descricao}}</span>
              </p>
            </ion-item>
          </ion-list>
        </ion-card>
      </ion-col>

      <ion-col class="alinhamento" size="auto">
        <i class="fa-regular fa-chevron-right"></i>
      </ion-col>
    </ion-row>

    <sem-registro *ngIf="!historicoList.length"></sem-registro>
  </ion-card>

  <ion-modal
    trigger="open-modal"
    [initialBreakpoint]="0.55"
    [breakpoints]="[0, 0.25, 0.5, 0.75]"
    handleBehavior="cycle"
  >
    <ng-template>
      <ion-card-content>
        <form
          class="sample-form validations-form"
          [formGroup]="validations_form"
          (ngSubmit)="onSubmit(validations_form.value)"
        >
          <ion-row class="prover-datepicker">
            <ion-col size="12" class="ion-padding-horizontal">
              <ion-select
                labelPlacement="stacked"
                interface="action-sheet"
                placeholder="{{'Acompanhamentos' | translate}}"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="filtroResponsavel"
              >
                <div slot="label" class="slot-label">{{'Acompanhamentos' | translate}}</div>
                <ion-select-option *ngFor="let v of list" [value]="v.id">{{v.nome}}</ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row>

          <ng-container>
            <prover-datepicker
              [labelName]="'Data Início'"
              [id]="'dataInicio'"
              [(dateTime)]="dataInicio"
              formControlName="dataInicio"
              [required]="true"
            ></prover-datepicker>
          </ng-container>

          <ng-container>
            <prover-datepicker
              [labelName]="'Data Fim'"
              [id]="'dataFim'"
              [(dateTime)]="dataFim"
              formControlName="dataFim"
              [required]="true"
            ></prover-datepicker>
          </ng-container>

          <div class="down">
            <ion-button class="btn-default" expand="block" type="submit" [disabled]="!validations_form.valid"
              >{{'Filtrar' | translate}}</ion-button
            >
          </div>
        </form>
      </ion-card-content>
    </ng-template>
  </ion-modal>
</ion-content>
